export default __webpack_public_path__ + "static/cutterfp-logo-white-dea82af0c77f988562a1cf73d6cc89f0.svg";